export default __webpack_public_path__ + "static/media/reunion23.a847f23b.jpg";